import React from 'react';
import './Holding.css';

export default function Holding() {
  return (
    <div className="holding">
      <header className="holding__header">
        <div className="holding__mark">
          <span className="holding__mark-glyph" aria-hidden="true">◆</span>
          <span className="holding__mark-name">MySecureRoom</span>
        </div>
        <div className="holding__meta">v2.0 · building in the open</div>
      </header>

      <main className="holding__main">
        <h1 className="holding__title">
          A private<br />
          life OS.
        </h1>
        <p className="holding__lede">
          Built so no one — not even us —<br />
          can read your data.
        </p>
        <p className="holding__status">
          <span className="holding__status-dot" aria-hidden="true" />
          Under construction. Back soon.
        </p>
      </main>

      <footer className="holding__footer">
        <div className="holding__footer-left">
          End-to-end encrypted
          <span className="holding__sep" aria-hidden="true">·</span>
          Zero knowledge
          <span className="holding__sep" aria-hidden="true">·</span>
          Your keys, your data
        </div>
        <div className="holding__footer-right">Est. 2026</div>
      </footer>
    </div>
  );
}
